import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import useGetTournaments from 'hooks/tournaments/tournaments';

import { onboardingSelector } from 'store/slices/onboarding';
import { close, open } from 'store/slices/tournamentPopup';

import { differenceDateTime } from 'utils/date';
import { findPathPages } from 'utils/pages';
import { getTournamentsByStatus } from 'utils/tournaments';

import Banner from 'components/TournamentPopup/Banner/Banner';
import Button from 'components/UI/Button/Button';
import Dialog from 'components/UI/Dialog/Dialog';

import { PAGE_PATH } from 'components/config/pages';
import { STATUSES } from 'components/config/tournaments';

import styles from 'components/TournamentPopup/TournamentPopup.module.scss';

const TournamentPopup = () => {
  const dispatch = useDispatch();

  const [tournament, setTournament] = useState(null);

  const isVisibleOnboarding = useSelector(onboardingSelector.getVisible);

  const tournamentEvents = useGetTournaments();

  const handleClose = useCallback(() => {
    dispatch(close());
    setTournament(null);
  }, []);

  useEffect(() => {
    if (!isVisibleOnboarding) {
      const running = getTournamentsByStatus(
        tournamentEvents,
        STATUSES.running,
      );
      const comingSoon = getTournamentsByStatus(
        tournamentEvents,
        STATUSES.comingSoon,
      );

      if (running.length) {
        setTournament(running[0]);
      } else if (comingSoon.length) {
        setTournament(comingSoon[0]);
      }
    }
  }, [tournamentEvents]);

  useEffect(() => {
    if (tournament) {
      if (tournament.eventStatus === STATUSES.running) {
        dispatch(open(tournament.eventId));
      } else {
        const { date } = differenceDateTime(
          new Date(tournament.schedule?.activeStatusStartTime),
        );
        if (date <= 7) {
          dispatch(open(tournament.eventId));
        }
      }
    }
  }, [tournament]);

  if (!tournament) return null;

  return (
    <Dialog handleClose={handleClose} open options={{ hideScroll: true }}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Dear partners, we invite you to take part in ANNIVERSARY RUSH
          TOURNAMENT.
        </div>
        <div className={styles.subTitle}>
          This activity is all about celebration! A celebration of our
          continuous growth over the past 8 years — made possible only through
          your cooperation and support. Join this exciting adventure! <br />
          Play, compete, and win in an engaging tournament, where our cheeky
          chicken will keep you on your toes — your focus must be on keeping it
          alive, or else… things might get a little too hot!
        </div>
        <Banner event={tournament} />
        <div className={styles.moreBtn}>
          <Button
            component={Link}
            to={findPathPages(PAGE_PATH.TOURNAMENTS_ITEM).replace(
              ':eventId',
              tournament.eventId,
            )}
            onClick={handleClose}
          >
            Learn more
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default TournamentPopup;
